/**
 * TemplateCard - Individual Template Card Component
 * Displays template information in a card format
 */

import React from 'react';
import type { Project } from '@fmeastudio/shared';
import './TemplateCard.css';

interface TemplateCardProps {
  template: Project;
  onSelect: () => void;
}

export function TemplateCard({ template, onSelect }: TemplateCardProps) {
  // Format date
  const formatDate = (date: Date | string) => {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div
      className="template-card"
      onClick={onSelect}
      data-testid="template-card"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
    >
      <div className="template-card-header">
        <h3 className="template-card-title">{template.name}</h3>
        {template.industry && <span className="template-card-industry">{template.industry}</span>}
      </div>

      <div className="template-card-body">
        {template.description && (
          <p className="template-card-description">{template.description}</p>
        )}
      </div>

      <div className="template-card-footer">
        <div className="template-card-meta">
          <span className="template-card-date">Created {formatDate(template.createdAt)}</span>
        </div>
        <button
          className="template-card-button"
          onClick={(e) => {
            e.stopPropagation();
            onSelect();
          }}
        >
          Use Template →
        </button>
      </div>
    </div>
  );
}
